export const INVITATION_DETAIL_BUILDING_SEARCH_PLACEHOLDER = 'Search Property..';

export const EMPTY_INVITATION_DETAIL_BUILDING_FILTER = {
  options: {},
  searchText: '',
  searchPlaceholder: INVITATION_DETAIL_BUILDING_SEARCH_PLACEHOLDER,
};

export const parseInvitationDetailBuildingFilters = (searchParams, _paramKey, fallback) => {
  const propertyTypeParam = searchParams.get('propertyType') || searchParams.get('buildingType');
  return {
    selectedBType: propertyTypeParam
      ? propertyTypeParam.split(',').filter(Boolean)
      : fallback.selectedBType,
    isSHouse: searchParams.get('studentHousing')
      ? searchParams.get('studentHousing').split(',').filter(Boolean)
      : fallback.isSHouse,
  };
};

export const serializeInvitationDetailBuildingFilters = (filters) => ({
  propertyType:
    Array.isArray(filters.selectedBType) && filters.selectedBType.length > 0
      ? filters.selectedBType.join(',')
      : '',
  studentHousing:
    Array.isArray(filters.isSHouse) && filters.isSHouse.length > 0
      ? filters.isSHouse.join(',')
      : '',
});

export const areInvitationDetailFilterArraysEqual = (a = [], b = []) =>
  a.length === b.length && a.every((value, index) => value === b[index]);
